import React from 'react';
import { X } from 'lucide-react/dist/esm/icons';
import LocationSearch from './LocationSearch';

const AddLocationModal = ({ isOpen, onClose, onAddLocation }) => {
  if (!isOpen) return null;

  const handleLocationAdd = (location) => {
    onAddLocation(location);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <h2>Add Location</h2>
        <p>Search for a coastal location to add to your list</p>

        <LocationSearch 
          onLocationAdd={handleLocationAdd}
          autoFocus={true}
        />

        <div className="modal-actions">
          <button className="modal-button secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLocationModal; 